module.exports = __webpack_public_path__ + "static/media/img-login.b49cb531.svg";